import { render, staticRenderFns } from "./GlIconVennPon.vue?vue&type=template&id=66db2da2&scoped=true&"
import script from "./GlIconVennPon.vue?vue&type=script&lang=js&"
export * from "./GlIconVennPon.vue?vue&type=script&lang=js&"
import style0 from "./GlIconVennPon.vue?vue&type=style&index=0&id=66db2da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db2da2",
  null
  
)

export default component.exports